import { render, staticRenderFns } from "./zcm-purchase-blocked-dialog.vue?vue&type=template&id=585cdfea"
import script from "./zcm-purchase-blocked-dialog.vue?vue&type=script&lang=js"
export * from "./zcm-purchase-blocked-dialog.vue?vue&type=script&lang=js"
import style0 from "./zcm-purchase-blocked-dialog.vue?vue&type=style&index=0&id=585cdfea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports